import * as core from '../../../../../../../core'
import * as jiraStatus from '../jira-status'

export const RESOURCE = {
  payload: {
    description: 'The Jira issue is actively being worked',
    enumId: core.dms.models.Enum.Id.from({
      partialId: jiraStatus.RESOURCE.payload.partialId,
    }),
    id: 'In Progress',
    name: 'In Progress',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
